// Trigger methodology chart once in view
ScrollTrigger.batch("#jsChartMethodology", {
    toggleClass: "in-view",
    start: 'top 40%',
    once: true,
});

// Animate nummbers when scrolled into view
gsap.utils.toArray(".jsCounter").forEach(box => {
  var tler = gsap.from(box, {
    textContent: "0",
    duration: 1,
    ease: "power1.inOut",
    opacity: 0,
    once: true,
    modifiers: {
      textContent: value => formatNumber(value, 0)
    },
    scrollTrigger: {
      trigger: box,
      start: "100px 80%",
      end: "+=100",
      toggleActions: "play none none reverse",
      once: true
    }
  });
});

// Format numbers that may contain percentages or plus signs
function formatNumber(value, decimals) {
  // Check if the value contains a percent or plus sign
  const isPercentage = typeof value === "string" && value.includes("%");
  const isPlus = typeof value === "string" && value.includes("+");

  // Remove percent and plus signs
  value = isPercentage ? value.replace("%", "") : isPlus ? value.replace("+", "") : value;

  // Convert the value to a number
  const numericValue = parseFloat(value);

  let formattedValue = isPercentage
    ? numericValue.toFixed(0) + "%" // Format as percentage
    : isPlus
    ? "+" + numericValue.toFixed(decimals) // Format as a number with a plus sign
    : Math.round(numericValue).toLocaleString('en-US'); // Format as an integer

  return formattedValue;
}

